import axios from 'axios';

// Shared seam for resolving a pasted URL through iframe.ly. Two pre-existing
// duplicates (Iframely.js, useValidateUrl.js) remain outside it, for a follow-up.
const resolveIframelyEmbed = async (url) => {
  const key = process.env.REACT_APP_IFRAMELY_KEY;
  const { data } = await axios.get(
    `https://iframe.ly/api/iframely?url=${encodeURIComponent(url)}&key=${key}`,
  );
  const player = data?.links?.player?.find((link) => link.type === 'text/html' && link.href);
  const thumbnail = data?.links?.thumbnail?.find((link) => link.href);
  return {
    data,
    playerUrl: player ? player.href : null,
    thumbnailUrl: thumbnail ? thumbnail.href : null,
  };
};

export default resolveIframelyEmbed;
